<template>
  <div class="forgot">
    <div class="forgot__form">
      <label v-if="!show" class="forgot__form--label" for=""
        >لطفا شماره همراه خود را وارد کنید.
      </label>
      <div v-if="!show" class="con3">
        <input
          v-model="email"
          class="forgot__form--input"
          type="text"
          placeholder="شماره همراه"
        />
        <font-awesome-icon class="i" icon="user" />
      </div>
      <div v-if="show" class="con3">
        <input
          v-model="code"
          class="forgot__form--input"
          placeholder="کد ارسال شده"
        />
        <font-awesome-icon class="i" icon="user" />
      </div>
      <div v-if="show" class="con3">
        <input
          v-model="pass"
          class="forgot__form--input"
          type="password"
          placeholder="کلمه عبور جدید"
        />
        <font-awesome-icon class="i" icon="user" />
      </div>
      <div v-if="show" class="con3">
        <input
          v-model="c_pass"
          class="forgot__form--input"
          type="password"
          placeholder="تکرار کلمه عبور جدید"
        />
        <font-awesome-icon class="i" icon="user" />
      </div>
      <input
        v-if="!show"
        @click.prevent="forgot_req"
        type="submit"
        value="ارسال در خواست"
        href=""
        class="forgot__form--btn"
      />
      <input
        v-if="show"
        @click.prevent="change_pass"
        type="submit"
        value="تغییر کلمه عبور"
        href=""
        class="forgot__form--btn"
      />
      <p v-if="show" class="notspan">کد ارسال شده تا یک ساعت معتبر است</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      code: "",
      pass: "",
      c_pass: "",
      show: false,
    };
  },
  created() {
    this.$store.state.load = false;
  },
  methods: {
    change_pass() {
      var that = this;
      this.$store.state.load = true;
      if (
        this.code.length == 0 ||
        this.pass.length == 0 ||
        this.c_pass.length == 0
      ) {
        that.$toastr.e("لطفا تمام فیلد ها را پر کنید.");
        that.$store.state.load = false;
      } else if (this.code.length != 6) {
        that.$toastr.e("طول کد  وارد شده باید غیر مجاز است.");
        that.$store.state.load = false;
      } else if (this.pass.length < 8 || this.c_pass.length < 8) {
        that.$toastr.e("طول رمز های وارد شده باید بیشتر از ۸ رقم باشد.");
        that.$store.state.load = false;
      } else if (this.c_pass != this.pass) {
        that.$toastr.e("رمز وارد شده با تکرار آن یکسان نیست.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/passwd/reset-conf/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          data: {
            code: this.code,
            new_pass: this.pass,
            new_pass_c: this.c_pass,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            // console.log(data);
            that.$toastr.s(data);
            that.show = true;
          },
          error: function (request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    forgot_req() {
      var that = this;
      this.$store.state.load = true;
      function validateEmail(email) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      this.email = this.email
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

      if (this.email.length != 11) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/passwd/reset-req/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          data: {
            cellphone: this.email,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            // console.log(data);
            that.$toastr.s(data);
            that.show = true;
          },
          error: function (request, textStatus, errorThrown) {
            // console.log(request.responseJSON.detail);
            if (request.responseJSON.detail) {
              that.$toastr.e(request.responseJSON.detail);
            } else {
              that.$toastr.e(request.responseJSON);
            }
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.notspan {
  margin-top: 2em;
  font-size: 0.6em;
  margin-right: auto;
  margin-left: auto;
  @media (max-width: 570px) {
    font-size: 0.5em;
  }
}
.forgot {
  width: 100%;
  height: 100vh;
  margin-top: 7.8em;
  display: flex;
  justify-content: center;
  align-items: center;
  .con3 {
    // background: red;
    width: 100%;
    display: flex;
    position: relative;
    margin-top: 1em;
    svg {
      position: absolute;
      right: 0;
      top: 50%;
      color: var(--sub-color);
      transform: translate(-100%, -60%);
    }
  }
  &__form {
    direction: rtl;
    display: flex;
    padding: 3em 3em;
    // justify-content: center;
    // align-items: center;
    flex-direction: column;
    min-height: 200px;
    width: 450px;
    background: var(--main-color);
    border-radius: 8px;
    border: 1px solid rgb(205, 221, 221);
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.164);
    &--label {
      //   font-size: 2em;
    }
    &--input {
      width: 100%;
      outline: none;
      color: var(--font-color);
      background: var(--bg-color);
      border: none;
      padding: 1em;
      padding-right: 2.5em;
      border-radius: 8px;
      //   background: red;
      font-family: "yekan", "lato";
    }
    &--btn {
      cursor: pointer;
      border: none;
      font-family: "yekan";
      text-decoration: none;
      color: var(--main-color);
      text-align: center;
      background: var(--sub-color);
      padding: 0.7em 2em;
      margin-top: 2em;
      border-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/forgot.vue